import { checkStatusForLogin } from 'shared/helpers/checkStatus'
import { axiosInstance } from 'network/apis';
import { parseJwt } from 'shared/helpers/functional'
import Storage from 'shared/helpers/storage'

const getUserInfoRequest = async (userId) => {
  return await axiosInstance.get(`user/user-info/${userId}`,  { handlerEnabled: true })
};

const getCognitoUserInfoRequest = async (userId) => {
  return await axiosInstance.get(`user/user-info/${userId}`, {params: {cognito: '1'}},  { handlerEnabled: true })
};
  
function loginUserFromComms (conferenceHash, userHash) {
    return fetch(`/v1/conf/${conferenceHash}/login`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ userHash }),
    })
    .then(checkStatusForLogin)
    .then(res => res.json())
  }
   
  export const updateUserTimezone = async (payload) => {
    return axiosInstance.post(`user/upsert-user-time-zone-selection`,{ userId: payload.userId, userSelectedTimeZone: payload.timezone } ,{ handlerEnabled: true })
  };

  export const matchCurrentPassword = async ({password, userId}) => {
    return axiosInstance.put(`reset-user-password/check-if-password-matches/${userId}`,{  password: password  } ,{ handlerEnabled: true })
  };

  export const putUserPasword = async (payload) => {
    return axiosInstance.patch(`reset-user-password/patch-user-from-profile/${payload.userId}`,{ password: payload.password } ,{ handlerEnabled: true })
   };

  export const fetchAllUsersDetails = async () => {
    return axiosInstance.get(`qstoolAdmin/get-all-users`,{ handlerEnabled: true })
   }; 

   export const updateAllowContactByEmail = async (payload) => {
    const tokenDecoded = Storage.getItem('accessToken') && parseJwt(Storage.getItem('accessToken')) 
    const pmId =  tokenDecoded ? tokenDecoded['custom:userId'] : null
    return axiosInstance.post(`unsubscribe/unsubscribe-user/${payload.userId}`,{ pmUserId: pmId, allowContactByEmail: payload.allowContactByEmail } ,{ handlerEnabled: false })
   };
 
export default{
    getUserInfoRequest,
    getCognitoUserInfoRequest,
    loginUserFromComms,
    matchCurrentPassword,
    putUserPasword,
    updateUserTimezone,
    fetchAllUsersDetails,
    updateAllowContactByEmail
}
